module.exports = __webpack_public_path__ + "414e20ed7c54d84644f9c42733a622ef.svg";